import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Link } from "react-router-dom";

function Dashboard() {
  return (
    <div className="container">
      <div className="row">
        <table style={{ width: "100%", tableLayout: "fixed" }}>
          <tbody>
            <tr style={{ marginBottom: 20 }}>
              <td style={{ textAlign: "center" }}>
                <a href="/in-play">
                  <img
                    src="https://hrx99.com/img/shiv99/inplay.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">IN PLAY</div>
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <a href="/profile">
                  <img
                    src="https://hrx99.com/img/shiv99/profile.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">PROFILE</div>
                </a>
              </td>
            </tr>
            <tr style={{ marginBottom: 20 }}>
              <td style={{ textAlign: "center" }}>
                <a href="/statement">
                  <img
                    src="https://hrx99.com/img/shiv99/statement.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">STATEMENT</div>
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <a href="/user/completed-games/">
                  <img
                    src="https://hrx99.com/img/shiv99/completed.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">COMPLETED GAMES</div>
                </a>
              </td>
            </tr>
            <tr style={{ marginBottom: 20 }}>
              <td style={{ textAlign: "center" }}>
                <a href="/user/ledgers/">
                  <img
                    src="https://hrx99.com/img/shiv99/ledger.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">MY LEDGER</div>
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <a href="/user/games/">
                  <img
                    src="https://hrx99.com/img/shiv99/casino.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">GAMES</div>
                </a>
              </td>
            </tr>
            <tr style={{ marginBottom: 20 }}>
              <td style={{ textAlign: "center" }}>
                <a href="/rules">
                  <img
                    src="https://hrx99.com/img/shiv99/rules.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">RULES</div>
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <a href="/password">
                  <img
                    src="https://hrx99.com/img/shiv99/password.png"
                    className="img-fluid"
                    style={{ height: 80 }}
                  />
                  <div className="ttl">CHANGE PASSWORD</div>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default Dashboard;
